/*
 * @Author: summer
 
 * @Date: 2019-08-12 09:48:47
 * @LastEditTime: 2023-01-11 14:02:30
 * @LastEditors: bbqin
 */
import axios from 'axios';
import ReactDOM from 'react-dom';
import Loading from '../base/Loading';
import { toast } from './toast';
import Gzip from './gzip';
import { getBusinessInfo } from './getBusinessInfo';
import ViewModel from './viewmodel';
import { getParamByLocation } from './utils';
import { setCookie, getCookie } from './cookie';
import { setGlobalStorage, getGlobalStorage } from './storage';
import handelExitPage from './exit.js';
import Cipher, { opaqueDecrypt } from './cipher';
import { syncAjax } from './ajaxsync';
import * as broadcastChannel from './broadcastChannel';
import { getAppReqParam } from './appUrlUtils';
import forwardUrl from './forwardUrl';
import { getParentWindow, getTopWindow } from './window.js'
import { localeLang } from './currentLocale';
import { encryptFormData } from './formDataEncrypt';

const serviceTip = localeLang === 'simpchn' ? '服务不可用' : 'Service Unavailable';
const unexpectedTip = localeLang === 'simpchn' ? '数据不能解析（解压或解密）' : 'Unexpected Compressed encrypted Data';

const errorMessageCatchHandle = function (props) {
    let message = props.message;
    if (message.indexOf('Unexpected') != -1 && message.indexOf('token') != -1 && message.indexOf('JSON') != -1) {
        return unexpectedTip;
    }
    if (message.indexOf('Malformed') != -1 && message.indexOf('UTF-8') != -1 && message.indexOf('data') != -1) {
        return unexpectedTip;
    }
    return props.message;
};

/**
 * 目前主要处理 500
 * @param {*} response 
 * @param {*} tipCallBack 
 * @param {*} url 
 */
const errorStatusCatchHandle = function (response = {}, tipCallBack, url, headers = {}) {
    let data = { type: 'danger', message: serviceTip },
        status = response.status || (response.response ? response.response.status : 200);
    // if (Object.prototype.toString.call(response) === '[object String]' && response.indexOf('<html>') !== -1) {
    //     status = response.indexOf('502') !== -1 ? 502 : '';
    //     status = response.indexOf('503') !== -1 ? 503 : status;
    //     status = response.indexOf('500') !== -1 ? 500 : status;
    // }
    if (status === 500 || status === 501 || status === 503 || status === 502) {
        data.message = `"${headers['nccloud-service'] || ''}" ${serviceTip}; url:${url},status: ${status}`;
        tipCallBack && tipCallBack(data, url);
        return null;
    }
    if (status === 504) {
        data.message = `"${headers['nccloud-service'] || ''}" ${localeLang === 'simpchn' ? '网关超时' : 'Gateway Timeout'}; url:${url},status: ${status}`;
        tipCallBack && tipCallBack(data, url);
        return null;
    }
    return response;
};

// 缓存一些常量用来做多页签（tab）通信
const sscopenkey = getParamByLocation(window.location.hash, 'sscopenkey'); // 共享服务可能不再使用
const urlDataC = getParamByLocation(window.location.hash, 'c') || getAppReqParam().appcode;
const urlDataP = getParamByLocation(window.location.hash, 'p') || getAppReqParam().pagecode;

const DEFAULT_DELAY_TIME = 1000;

//把请求成功的业务数据放在ViewModel的getRenderPageData上，执行获取业务数据之后的二开js
function dealSecDevData(params) {
    let extendCache = ViewModel.getData('_nccloud_extend_cache_data');
    let data;
    if(extendCache){
        for( let pop in extendCache){
            if(extendCache[pop] && extendCache[pop].dataAlreadyLoaded){
                data = extendCache[pop].dataAlreadyLoaded(params);
            }
        }
    }
    return data || params.res;
    // let data = ViewModel.dataAlreadyLoaded && ViewModel.dataAlreadyLoaded(params);
    // return data || params.res;
}

//把请求成功的业务数据放在ViewModel的getRenderPageData上，执行获取业务数据之后的二开js
function beforeAjaxSend(params) {
    let extendCache = ViewModel.getData('_nccloud_extend_cache_data');
    let data;
    if(extendCache){
        for( let pop in extendCache){
            if(extendCache[pop] && extendCache[pop].beforeAjaxSend){
                data = extendCache[pop].beforeAjaxSend(params);
            }
        }
    }
    return data || params;
    // let data = ViewModel.beforeAjaxSend && ViewModel.beforeAjaxSend(params);
    // return data || params;
}

// 是否第一次加签
let isNccsignSwitch = false; //原来是 false解决登录报非法攻击
let isNccsign = false;

// 添加一个加签处理方法 -- by bbqin
function addDataSign(data, userCode, {
    allin = false,
    headers = {},
}) {
    // console.log(data, userCode);
    if (
        typeof transSn === 'undefined' ||
        typeof transSign === 'undefined' ||
        // !userCode ||
        (headers && headers['Content-Type'] == 'multipart/form-data') // newData.append(  这种模式 先确定下 需不需要加签操作
    ) {
        return data;
    }
    // 先加签全部数据 或者部分数据

    // 这里会影响原字符串 （编码、位数？）导致后台解析不了字符串
    if (!allin) {
        let strDataSign = data.busiParamJson + '';
        // 加签 -- bbqin
        data.sysParamJson.sn = transSn(userCode);
        data.sysParamJson.signdata = transSign(strDataSign, userCode);
    } else {
        // 加签 -- bbqin
        // data.sysParamJson.sn = transSn(userCode);
        let dataStr = JSON.stringify(data) + '';
        headers['Identifications'] = transSign(dataStr, '');
    }
    // 这里是通过对象方式注入  headers  不符合设计原则 TODO 
    return data;
}

// 此时的cookie是当前界面唯一 如果放到ajax内部  
// 多个请求的情况下 会导致前面的cookie被覆盖  所有请求用的是第二次的cookie  而加密用的cookie是第一次的
let cookiets = (top && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
// 做一次 数据转型
cookiets = isNaN(cookiets) ? cookiets : Number(cookiets);
setCookie('cookiets', cookiets);
top && (getTopWindow().cookiets = cookiets);

export default function ajax({
    url = '/',
    method = 'post',
    data = {},
    async = true, //默认异步，同步false
    loading = true,
    print = false, // 针对打印接口
    windowContainer = window,
    loadingContainer,
    toastContainer,
    isDecrypt = true, // 一些特殊接口  不需要解密  比如注销
    isUpload = false, //附件专用
    isEncrypt = true, //是否走加密开关
    encryptForm = false,
    success = function (res) {
        console.log(res);
    },
    // 附件请求base64
    uploadResponse = function (res) {
        console.log(res);
    },
    error = function (res, url) {
        if (!res) return;
        console.error(res.type, res, url);
        let msgContent = JSON.stringify(res.message);
        const colors = ['danger', 'warning', 'info', 'success'];
        let color = colors.indexOf(res.type) != -1 ? res.type : 'danger';
        toast({ color, content: errorMessageCatchHandle({ message: msgContent }), container: toastContainer, mark: msgContent + url });
    },
    getCompleteErrorInfo = function (res) {
        //获取完整堆栈信息
        console.log(res);
    },
    mode = '',
    params = {},
    from = '',
    headers = { 'Content-Type': 'application/json;charset=UTF-8' },
    delayTime,
    sysParameter,
    requestJSON = false,
    sysAppcode, //云原生小部件传appcode,后台做服务分发
}) {
    let stack = [];
    let div;
    // modify by wangyang
    div = windowContainer.document.createElement('div');
    windowContainer.document.body.appendChild(div);
    div.className = 'nc-loading-hidden';

    //console.error(url,"ajax请求开始");
    typeof getTopWindow().startAjax === 'function' && getTopWindow().startAjax(url);

    let gziptools = new Gzip();
    // 解决 接口报错  清理本地的cookie的情况 报错 by bbqin
    //双cookie验证 --liuxis
    cookiets = headers['cookiets'] = String(headers['cookiets'] || ((top && getTopWindow().cookiets) || getCookie('cookiets') || Date.now()));
    setCookie('cookiets', cookiets);

    function showLoading(container) {
        if (loading) {
            if (stack.length === 0) {
                setTimeout(() => {
                    container.className = 'nc-loading-show';
                }, delayTime || DEFAULT_DELAY_TIME);
                // modify by wangyang
                loadingContainer
                    ? ReactDOM.render(<Loading show={true} container={loadingContainer} />, container)
                    : ReactDOM.render(<Loading show={true} fullScreen container={container} />, container);
            }
            stack.push(url);
        }
    }

    function hideLoading(container) {
        stack.pop();
        if (container && stack.length === 0) {
            container.className = '';
            ReactDOM.unmountComponentAtNode(container);
            // 页面有太多多余的div 做一个div的清除操作 bbqin
            setTimeout(() => {
                // 这里加setTimeout  是为了保证 showLoading中setTimeout和这里的顺序
                container.parentElement && container.parentElement.removeChild(container);
            }, delayTime || DEFAULT_DELAY_TIME);
        }
    }

    //window.actionName

    let { app, appcode, custom } = getAppReqParam();

    appcode = sysAppcode || appcode || '10228888';

    let tabid = getTopWindow().WebSocketTabid || '';

    let busiaction = app;
    if (window.actionName) {
        busiaction = busiaction + '-' + window.actionName;
    }
    // 此处 yanggqm修改 formData上传。
    let sysParamJson = {},
        newData;
    if (sysParameter) {
        sysParamJson = sysParameter;
    } else {
        sysParamJson = {
            busiaction,
            appcode,
            tabid,
            ts: new Date().getTime(),
            from,
            pagecs: cookiets,
        };
        if (custom) {
            sysParamJson.custom = custom;
        }
    }

    // 添加一个参数给nginx 转发使用
    headers['transcode'] = headers['transcode'] || appcode;
    // 添加一个参数给nginx 转发使用
    let crux = headers['crux'] = String(headers['crux'] || (new Date().getTime()));

    // 用户信息获取 --bbqin
    let userInfos = getBusinessInfo();
    let userCode = userInfos && userInfos.userCode ? userInfos.userCode : null;

    // contentType 
    let headersContentType = 'default';
    if (headers['Content-Type'] == 'multipart/form-data') {
        headersContentType = 'multipart/form-data';
        newData = data;

        let sysParamData = {};

        if (sysParameter) {
            sysParamData = sysParameter;
        } else {
            sysParamData = {
                sys_busiaction: busiaction,
                sys_appcode: appcode,
                sys_tabid: getTopWindow().WebSocketTabid || '',
                sys_ts: String(new Date().getTime()),
                sys_custom: custom || '',
            };
        }
        if (encryptForm) {
            //与formDownlod一样加密
            //添加加密后系统参数
            newData.append('sysParamJson', encryptFormData(JSON.stringify(sysParamData)));
            newData.append('sys_appcode', appcode);
            //获取业务参数加密
            let decryptbusiParami = encryptFormData(newData.get('busiParamJson'));
            newData.set('busiParamJson', decryptbusiParami);

        } else {
            for (let key in sysParamData) {
                newData.append(key, sysParamData[key]);
            }
        }

    } else {
        let strData = typeof data === 'string' ? data : JSON.stringify(data);
        newData = {
            busiParamJson: strData,
            sysParamJson,
        };
    }

    let flag = true;
    //秘钥
    let aeskey = '';
    //压缩开关
    let gzipFlag = false;
    //加密开关
    let cipherFlag = false;
    //加签开关
    let isNccsign = false;

    let cruxId = String(crux);

    let excludeChiperUrl = {
        "/nccloud/riart/login/init.do": true,
        "/nccloud/riart/login/verfiy.do": true,
        "/nccloud/login/psw/reset.do": true,
        "/nccloud/riart/login/forpsw.do": true,
        "/nccloud/riart/login/toreset.do": true,
        "/nccloud/riart/login/rand.do": true,
    };

    //获取系统级开关
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch'));
    if (NCC_SYS_Switch === null) {
        let reqData = {
            sysParamJson: {
                busiaction: '查询系统开关',
                pagecs: cookiets,
                ts: new Date().getTime(),
            },
        };
        let headers = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
        reqData = JSON.stringify(addDataSign(reqData, '', { allin: true, headers: headers }));
        syncAjax({
            type: 'post',
            url: '/nccloud/platform/total/switch.do',
            async: false,
            headers: headers,
            data: reqData,
            success: res => {
                if (res) {
                    res = JSON.parse(res);
                    if (res.data) {
                        NCC_SYS_Switch = res.data || {};
                        let localStorageSwitch = localStorage.getItem('storeCipher');
                        //缓存是否加密开关变化了
                        if (localStorageSwitch != NCC_SYS_Switch.localStorage) {
                            //localStorage加密开关与上次不一致，则清空所有localStorage内容
                            localStorage.clear();
                        }
                        localStorage.setItem('NCC_SYS_Switch', JSON.stringify(NCC_SYS_Switch));
                        //开启关闭自动化测试开关
                        localStorage.setItem('storeCipher', NCC_SYS_Switch.localStorage ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_automated_', NCC_SYS_Switch.automated_test ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_extend_style_', NCC_SYS_Switch.extendstyle ? '1' : '0');
                        sendAjax();
                    }
                }
            }
        });
    } else {
        sendAjax();
    }

    function sendAjax() {
        gzipFlag = NCC_SYS_Switch.gzip;
        cipherFlag = NCC_SYS_Switch.aesKey;
        isNccsign = NCC_SYS_Switch.mark;

        aeskey = opaqueDecrypt(getGlobalStorage('localStorage', 'cowboy'));
        aeskey = cruxId + aeskey.substring(0, aeskey.length - cruxId.length);

        // 将是否加密缓存到组件单例上
        if (excludeChiperUrl[url] || !isEncrypt) cipherFlag = false;

        Cipher.CipherFlag = cipherFlag;

        let extendParams = beforeAjaxSend({ data: newData, ajaxUrl: url, method, params });
        newData = extendParams.data;
        // add by bbqin
        newData = isNccsign ? addDataSign(newData, userCode, { allin: true, headers }) : newData;

        //请求时区开关
        getTimeZone();

        //根据前端分流 修改url
        forwardUrl({
            url,
            busiaction,
            userId: userInfos && userInfos.userId,
            gzipFlag,
            pagecs: cookiets,
            userCode: userInfos && userInfos.userCode,
            cipherFlag: cipherFlag,
            aeskey,
            crux,
            cookiets,
        }, newUrl => { //修改url后发请求
            url = newUrl;

            //执行ajax请求
            if (async) {
                //异步
                asyncAxios();
            } else {
                //同步
                syncAxios();
            }
        });
    }

    //异步请求
    function asyncAxios() {
        axios({
            method,
            params,
            headers,
            url,
            data: newData,
            withCredentials: true,
            transformRequest: [
                function (data) {
                    showLoading(div);
                    // 如果 form-data 方式提交  不进行加密压缩
                    if (headersContentType === 'multipart/form-data') {
                        return data;
                    }
                    let gData = '';
                    if (gzipFlag) {
                        gData = gziptools.zip(JSON.stringify(data));
                    } else {
                        gData = JSON.stringify(data);
                    }
                    return Cipher.encrypt(gData, aeskey);
                },
            ],
            transformResponse: [
                function (data, headers) {
                    //处理401
                    hideLoading(div);
                    flag = handelExitPage(headers, flag);
                    if (flag) {
                        try {
                            // 先进行 解密处理 bbqin
                            data = (typeof data === 'string' && !print && isDecrypt) ? Cipher.decrypt(data, aeskey) : data;
                            if (gzipFlag) {
                                let resData = print ? data : gziptools.unzip(data);
                                return resData;
                            } else {
                                return isJSON(data) ? JSON.parse(data) : data;
                            }
                        } catch (e) {
                            return null
                        }
                    } else {
                        return null;
                    }
                },
            ],
        })
            .then(res => {
                if (res) {
                    typeof getTopWindow().endAjax === 'function' && getTopWindow().endAjax(url);
                    if (mode === 'normal') {
                        res = dealSecDevData({
                            res,
                            ajaxUrl: url,
                            ts: new Date().getTime(),
                            c: urlDataC,
                            p: urlDataP,
                        });

                        success(res);
                        // 添加storage事件触发 by bbqin
                        broadcastChannel && broadcastChannel.broadcast(sscopenkey || 'TabBroadcast', {
                            ajaxUrl: url,
                            sscopenkey,
                            ts: new Date().getTime(),
                            c: urlDataC,
                            p: urlDataP,
                        });
                    } else {
                        if (res.data.success || res.success) {
                            res.data = dealSecDevData({
                                res: res.data,
                                ajaxUrl: url,
                                ts: new Date().getTime(),
                                c: urlDataC,
                                p: urlDataP,
                            });

                            success(res.data);
                            // 添加storage事件触发 by bbqin
                            broadcastChannel && broadcastChannel.broadcast(sscopenkey || 'TabBroadcast', {
                                ajaxUrl: url,
                                sscopenkey,
                                ts: new Date().getTime(),
                                c: urlDataC,
                                p: urlDataP,
                            });
                        } else {
                            getCompleteErrorInfo(res);
                            if (!errorStatusCatchHandle(res, error, url, res.headers)) {
                                return null;
                            }
                            // errorStatusCatchHandle(res, error, url, res.headers);
                            //throw new Error(res.data.error.message);
                            // data结构 res = { data: null,error:{type,message} }
                            error(res.data && res.data.error, url);
                        }
                    }
                }
            })
            .catch(res => {
                hideLoading(div);
                if (flag) {
                    let data = res;
                    if (!errorStatusCatchHandle(data, error, url, res.response ? res.response.headers : {})) {
                        return null;
                    }
                    data = typeof data === 'string' && isDecrypt ? Cipher.decrypt(data, aeskey) : data;
                    if (print) { // 这里就是为了捕捉 print情况下压缩了
                        data = gziptools.unzip(data);
                    }
                    // 添加 特殊接口响应状态的判断 如400
                    if (data.response && data.response.data) {
                        data = data.response.data;
                        data = data.error || data;
                    }

                    error(data, url);
                } else {
                    // 添加 特殊接口响应状态的判断 如400
                    // if (res.response && res.response.data) {
                    // 	res = res.response.data;
                    // }
                    // error(res, url);
                }
            });
    }

    //同步请求
    function syncAxios() {
        //同步
        let requestData = JSON.stringify(newData);

        if (gzipFlag) {
            requestData = gziptools.zip(JSON.stringify(newData));
        }
        syncAjax({
            type: method,
            url, //添加自己的接口链接
            data: Cipher.encrypt(requestData, aeskey),
            async,
            headers,
            before() {
                showLoading(div);
            },
            success(str, xhr) {
                hideLoading(div);
                // 附件请求base64
                if (isUpload) {
                    uploadResponse(str);
                } else {
                    try {
                        typeof getTopWindow().endAjax === 'function' && getTopWindow().endAjax(url);
                        let res = null;
                        str = typeof str === 'string' && isDecrypt ? Cipher.decrypt(str, aeskey) : str;
                        if (gzipFlag) {
                            res = gziptools.unzip(str);
                        } else {
                            res = JSON.parse(str);
                        }
                        if (res.success) {
                            res = dealSecDevData({
                                res,
                                ajaxUrl: url,
                                ts: new Date().getTime(),
                                c: urlDataC,
                                p: urlDataP,
                            });

                            success(res);
                            // 添加storage事件触发 by bbqin
                            broadcastChannel && broadcastChannel.broadcast(sscopenkey || 'TabBroadcast', {
                                ajaxUrl: url,
                                sscopenkey,
                                ts: new Date().getTime(),
                                c: urlDataC,
                                p: urlDataP,
                            });

                        } else {
                            getCompleteErrorInfo(res);
                            if (!errorStatusCatchHandle(res, error, url, xhr ? { 'nccloud-service': xhr.getResponseHeader('Nccloud-Service') || '' } : {})) {
                                return null;
                            }
                            //throw new Error(res.error.message);
                            error(res.error, url);
                        }
                    } catch (e) {
                        error(e, url);
                    }
                }
            },
            error(status, statusText) {
                hideLoading(div);
                error(statusText, url);
            },
        });
    }

    function getTimeZone() {
        let NCC_SYS_Timezone = JSON.parse(localStorage.getItem('NCC_SYS_Timezone'));
        if(!NCC_SYS_Timezone && (userInfos && userInfos.userCode)){
            let dataParams = {
                sysParamJson: {
                    pagecs: cookiets,
                    busiaction: '分流',
                    ts: new Date().getTime(),
                },
            };
            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'crux': crux,
                'cookiets': cookiets,
                'transcode': appcode,
            };
            dataParams = addDataSign(dataParams, '', { allin: true, headers: headers });
            // 添加一个参数给nginx 转发使用
            // axios({
            //     method: 'post',
            //     headers: headers,
            //     url: '/nccloud/platform/pub/timezone.do',
            //     data: dataParams,
            //     transformRequest: [
            //         function (data) {
            //             let gData = '';
            //             if (gzipFlag) {
            //                 gData = gziptools.zip(JSON.stringify(data));
            //             } else {
            //                 gData = JSON.stringify(data);
            //             }
            //             return Cipher.encrypt(gData, aeskey);
            //         },
            //     ],
            //     transformResponse: [
            //         function (data, headers) {
            //             flag = handelExitPage(headers, flag);
            //             if (flag) {
            //                 // 先进行 解密处理 bbqin
            //                 data = Cipher.decrypt(data, aeskey);
            //                 if (gzipFlag) {
            //                     return gziptools.unzip(data);
            //                 } else {
            //                     return JSON.parse(data);
            //                 }
            //             } else {
            //                 return null;
            //             }
            //         },
            //     ],
            // }).then(res => {
            //     if (res.data && res.data.data) {
            //         NCC_SYS_Timezone = res.data.data;
            //         localStorage.setItem('NCC_SYS_Timezone', JSON.stringify(NCC_SYS_Timezone)); 
            //     }
            // });
            dataParams = JSON.stringify(dataParams);
            if (gzipFlag) {
                dataParams = gziptools.zip(dataParams);
            }
            syncAjax({
                type: 'post',
                url: '/nccloud/platform/pub/timezone.do',
                async: false,
                headers: headers,
                data: Cipher.encrypt(dataParams, aeskey),
                success: res => {
                    if (res) {
                        res = typeof res === 'string' ? Cipher.decrypt(res, aeskey) : res;
                        if (gzipFlag) {
                            res = gziptools.unzip(res);     
                        } else if(isJSON(res)) {
                            res = JSON.parse(res);
                        }
                        if (res.data) {
                            NCC_SYS_Timezone = res.data;
                            localStorage.setItem('NCC_SYS_Timezone', JSON.stringify(NCC_SYS_Timezone));                       
                        }
                    }
                },
            });
        } 
    }
}

export { ajax };

function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.log('error：' + str + '!!!' + e);
            return false;
        }
    }
    console.log('It is not a string!');
}

